"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderDataGridCell_unstable", {
    enumerable: true,
    get: function() {
        return renderDataGridCell_unstable;
    }
});
const _renderTableCell = require("../TableCell/renderTableCell");
const renderDataGridCell_unstable = (state)=>{
    return (0, _renderTableCell.renderTableCell_unstable)(state);
};
